import React, { useEffect } from "react";
import "./App.scss";
import MainPage from "./pages/main-page/main-page";
import HeaderBlock from "./components/header-block/header-block";
import FooterBlock from "./components/footer-block/footer-block";
import { gsap, ScrollTrigger } from "gsap/all";

const App = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
  }, [])

  return (
    <div className="app">
      <HeaderBlock />
      <MainPage />
      <FooterBlock />
    </div>
  );
};

export default App;
